import dayjs from "dayjs";
import { Period, State } from "./types";

export const PERIODS_TITLE: Record<Period, string> = {
  [Period.ONE_MONTH]: "1M",
  [Period.SIX_MONTH]: "6M",
  [Period.YEAR_TO_DAY]: "YTD",
  [Period.ONE_YEAR]: "1Y",
};

export const TIME_RANGE_OFFSET: Record<Period, () => dayjs.Dayjs> = {
  [Period.ONE_MONTH]: () => dayjs.utc().add(-1, "M"),
  [Period.SIX_MONTH]: () => dayjs.utc().add(-6, "M"),
  [Period.YEAR_TO_DAY]: () => dayjs.utc(`${dayjs().year()}-01-01`),
  [Period.ONE_YEAR]: () => dayjs.utc().add(-1, "y"),
};

export const DEFAULT_STATE: State = {
  rates: null,
  isLoading: false,
  isError: false,
};
